import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../context/AuthContext';
import { getBalance } from '../../services/api';

const Navbar = () => {
  const { user } = useAuth();
  const [balance, setBalance] = useState(0);
  const hasFetchedBalance = useRef(false);

  useEffect(() => {
    if (!hasFetchedBalance.current && user) {
      hasFetchedBalance.current = true;
      fetchBalance();
    }
  }, [user]);

  const fetchBalance = async () => {
    try {
      const response = await getBalance();
      if (response?.data?.success) {
        setBalance(parseFloat(response.data.balance) || 0);
      }
    } catch (error) {
      console.error('Failed to fetch balance');
    }
  };

  const displayName = user?.email?.split('@')[0] || user?.phone || 'User';

  return (
    <nav className="navbar dashboard-hero">
      <div className="dashboard-hero-content">
        <div className="dashboard-hero-copy">
          <p className="dashboard-hero-kicker">Dashboard Overview</p>
          <h2 className="dashboard-hero-title">Welcome back, {displayName}</h2>
          <p className="dashboard-hero-subtitle">
            Monitor your assets, activity, and performance at a glance.
          </p>
        </div>

        <div className="dashboard-balance-card">
          <p className="dashboard-balance-label">Available Balance</p>
          <div className="dashboard-balance-value-wrap">
            <span className="dashboard-balance-value">{balance.toFixed(2)}</span>
            <span className="dashboard-balance-unit">USDT</span>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;